import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import compose from "recompose/compose";
import { Button } from "reactstrap";
import "./style.css";
import Api from "../../services/api";
import MainLoader from "../../components/MainLoader";
import ReactExport from "react-export-excel";
import ReportTable from "./../../components/CustomTable/ReportTable";
import { BounceLoader } from "react-spinners";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      resData: [],
      columns: null,
      activeTab: "local",
      categories: [],
      isLoading: true,
      searchInput: "",
      dataReport: [],
      fy: null,
      fyId: 0,
      fyList: [],
      provinceId: sessionStorage.getItem("provinceId")
        ? sessionStorage.getItem("provinceId")
        : 0,
      provinceList: [],
      districtId: 0,
      districtList: [],
      isDataLoading: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  _getCategories = async () => {
    let catRes = await Api.getCategories();
    return catRes.response;
  };

  _getReportData = async () => {
    this.setState({
      isDataLoading: true,
    });
    let sumRes = await Api.getReportData({
      fiscal_year_id: this.state.fyId,
      province_id: this.state.provinceId,
    });
    this.setState({
      isDataLoading: false,
    });
    return sumRes.response;
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  async componentDidMount() {
    let fiscal;
    if (localStorage.getItem("user")) {
      fiscal = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
    }
    await this.setState({
      fyId: fiscal ? fiscal : localStorage.getItem("fiscalYear"),
    });

    this._getFiscalyear();
    this._getProvinceList();

    const { history } = this.props;
    let categories = await this._getCategories();
    let summary = await this._getReportData();
    this.setState({
      categories: categories,
      dataReport: summary,
      resData: summary,
    });
  }

  _getFilteredReportData = async (params) => {
    this.setState({
      isDataLoading: true,
    });
    let districtName;
    let provinceName;
    if (params.district_id) {
      districtName = this.state.districtList.find(
        (x) => x.id.toString() === params.district_id.toString()
      ).name;
    }

    if (params.province_id) {
      provinceName = this.state.provinceList.find(
        (x) => x.id.toString() === params.province_id.toString()
      ).name;
    }

    let filteredData;
    if (params.district_id) {
      filteredData = this.state.resData.filter(
        (x) => x.district === districtName
      );
    } else if (params.province_id) {
      filteredData = this.state.resData.filter(
        (x) => x.province === provinceName
      );
    } else {
      filteredData = this.state.resData;
    }
    if (filteredData) {
      this.setState({ dataReport: filteredData });
    }

    this.setState({
      isDataLoading: false,
    });
  };

  _getFiscalyear = async () => {
    let fyList = await Api.getFyList();
    this.setState({ fyList: fyList.response });
  };

  _getProvinceList = async () => {
    let provinceListRes = await Api.getProvinceList();

    this.setState({
      provinceList: provinceListRes.response,
    });
  };

  _getDistrictList = async (provinceId) => {
    let districtListRes = await Api.getDistrictList(provinceId);

    this.setState({
      districtList: districtListRes.response,
    });
  };

  _handleFiscalYearChange = async (e) => {
    let fiscalYearId = e.target.value;
    this.setState({
      fyId: fiscalYearId,
      isDataLoading: true,
      provinceId: 0,
      districtId: 0,
      districtList: [],
    });
    localStorage.setItem("fiscalYear", fiscalYearId);

    let user = JSON.parse(localStorage.getItem('user'))
    
    // updating fiscal year of user locally
    if(user) {
        const updatedUser = {...user, user: {...user.user, fiscal_year_id: fiscalYearId} }
        localStorage.setItem('user', JSON.stringify(updatedUser))
    }
    

    const res = await Api.getReportData({
      fiscal_year_id: fiscalYearId,
      province_id: this.state.provinceId,
    });
    if (res && res.response) {
      this.setState({
        dataReport: res.response,
        resData: res.response,
        isDataLoading: false,
      });
    }
  };

  _import2Excel = () => {
    const { data, columns } = this.state;
    let filteredData = this._getFilteredData();
    filteredData.map((sData) => {
      Object.keys(sData.categories).map((categoryId, catIndex) => {
        sData[sData.categories[categoryId].name] = parseFloat(
          sData.categories[categoryId].score
        );
      });
    });
    let excelColumns = [
      <ExcelColumn key={"name"} label="मन्त्रालय तह" value="name" />,
      <ExcelColumn key={"province"} label="प्रदेश" value="province" />,
      <ExcelColumn
        key={"ocmcm"}
        label="मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालय"
        value="ocmcm"
      />,
      <ExcelColumn key={"score"} label="जम्मा प्राप्ताङ्क" value="score" />,
    ];
    if (filteredData.length > 0) {
      Object.keys(filteredData[0].categories).map((categoryId, catIndex) => {
        excelColumns.push(
          <ExcelColumn
            key={categoryId}
            label={filteredData[0].categories[categoryId].name}
            value={filteredData[0].categories[categoryId].name}
          />
        );
      });
      return (
        <ExcelFile
          element={
            <Button color="primary" style={{ marginRight: 10 }}>
              डाउनलोड
            </Button>
          }
        >
          <ExcelSheet data={filteredData} name="मन्त्रालय तह स्कोर टेबल">
            {excelColumns}
          </ExcelSheet>
        </ExcelFile>
      );
    }
  };

  _getFilteredData = () => {
    const { data, searchInput, columns } = this.state;
    const searchKeys = ["name", "province", "district", "categories"];
    if (searchInput) {
      let filteredData = data.filter((d) => {
        let found = false;
        searchKeys.map((searchKey) => {
          if (searchKey === "categories") {
            Object.keys(d.categories).map((catKey) => {
              if (d.categories[catKey].score.toString().includes(searchInput))
                found = true;
            });
          } else {
            if (d[searchKey].toString().includes(searchInput)) found = true;
          }
        });
        return found;
      });
      return filteredData;
    }
    return data;
  };

  _onSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };

  render() {
    const { data, columns, isLoading } = this.state;

    const headers = [
      { name: "क्र.स.", field: "id", sortable: false },
      { name: "प्रदेश", field: "province", sortable: false },
      // { name: "जिल्ला", field: "district", sortable: false },
      // { name: "नगरपालिका/ गाउँपालिका", field: "name", sortable: false },
    ];
    this.state.categories.map((item) =>
      headers.push({ name: item.name, field: item.name, sortable: false })
    );
    headers.push({ name: "जम्मा प्राप्तङ्क", field: "score", sortable: false });
    const dataSet1 = [];
    this.state.dataReport.map((item, i) =>
      dataSet1.push({
        id: i + 1,
        province: item.province,
        ocmcm: item.ocmcm,
        totalMarks: item.totalMarks,
        name: item.name,
        score: item.score,
        ...(item.categories &&
          item.categories.reduce(
            (a, v, i) => ({ ...a, [`cat-${i + 1}`]: v }),
            {}
          )),
      })
    );

    return (
      <MainLoader>
        <div className="">
          <div className="content">
            <div className="d-flex justify-content-between align-items-center mb-3 w-100">
              <h1 className="sub-heading m-0">मन्त्रालय तह स्कोर टेबल</h1>
              <ExcelFile
                element={
                  <Button
                    color="primary"
                    style={{ marginRight: 10, float: "right" }}
                  >
                    डाउनलोड
                  </Button>
                }
              >
                <ExcelSheet data={dataSet1} name="Status">
                  <ExcelColumn label="क्र.स." value="id" />
                  <ExcelColumn label="प्रदेश" value="province" />
                  <ExcelColumn label="मन्त्रालयको नाम" value="name" />
                  <ExcelColumn
                    label="मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालय"
                    value="ocmcm"
                  />
                  <ExcelColumn label="जम्मा प्राप्तङ्क" value="totalMarks" />
                  <ExcelColumn label="स्कोर" value="score" />
                </ExcelSheet>
              </ExcelFile>
            </div>
            <div className="">
              {this.state.isDataLoading ? (
                <div className="w-100 d-flex justify-content-center my-5">
                  {" "}
                  <BounceLoader color="#1f8cd5" />
                </div>
              ) : (
                <ReportTable
                  comments={this.state.dataReport}
                  categories={this.state.categories}
                  fyList={this.state.fyList}
                  fyId={this.state.fyId}
                  _handleFiscalYearChange={this._handleFiscalYearChange}
                  _handleProvinceChange={this._handleProvinceChange}
                  provinceList={this.state.provinceList}
                  provinceId={this.state.provinceId}
                  _handleDistrictChange={this._handleDistrictChange}
                  districtList={this.state.districtList}
                  districtId={this.state.districtId}
                />
              )}
            </div>
          </div>
        </div>
      </MainLoader>
    );
  }
}

const enhance = compose(withRouter);

export default enhance(Report);
